<!-- Monitoring_Reporting -->
<svg:path
    d="M1 251 L178 356 L178 353 L0 248 Z"
    fill="var(--base-border-bg-1)" />

<svg:path
    d="M178 356 L300 285 L300 282 L178 353 Z"
    fill="var(--base-border-bg-1)" />